var exports = {
  "kL": "ReportFlowThankYou.module__container___YzMyWU",
  "rf": "ReportFlowThankYou.module__body___YzMyWU",
  "uW": "ReportFlowThankYou.module__section___YzMyWU",
  "R_": "ReportFlowThankYou.module__heading___YzMyWU",
  "aP": "ReportFlowThankYou.module__box___YzMyWU",
  "nM": "ReportFlowThankYou.module__row___YzMyWU",
  "qg": "ReportFlowThankYou.module__rowText___YzMyWU",
  "G9": "ReportFlowThankYou.module__rowTitle___YzMyWU",
  "Z$": "ReportFlowThankYou.module__rowDescription___YzMyWU",
};

module.exports = exports;
